<template>
  <v-dialog v-model="dialog" persistent max-width="550px">
    <v-card>
      <v-card-title class="pl-4 pb-4">
        <span class="body-1">Перемістити завдання:</span>
        <span class="text-h5">{{ currentItem.title }}</span>
      </v-card-title>
      <v-card-text class="pb-0 pl-4">
        <v-container class="pb-0 pt-0">
          <v-row>
            <v-list dense class="pt-0 pb-0 mb-4">
              <v-list-item-group
                v-model="newSection"
                color="red lighten-2"
                :value="newSection"
              >
                <v-list-item
                  class="specification-list__item pl-0 pr-0"
                  disabled
                >
                  <v-list-item-content>
                    <v-list-item-title class="pl-1 pr-1 subtitle-1">
                      {{ currentItem.section }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-for="(section, i) in filteredSections(
                    sections,
                    currentItem
                  )"
                  :key="i"
                  class="specification-list__item pl-0 pr-0 "
                  :value="section"
                >
                  <template>
                    <v-list-item-content>
                      <v-list-item-title class="pl-1 pr-1 subtitle-1">
                        {{ section }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-row>
        </v-container>
        <p v-if="newSection" class="mb-0">
          Перемістити з <b>{{ currentItem.section }}</b> в
          <b>{{ newSection }}</b>
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="red lighten-2"
          text
          @click="update(currentItem, newSection)"
        >
          Зберегти
        </v-btn>
        <v-btn color="grey" text @click="cancel">
          Відмінити
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "currentItem", "sections"],
  data() {
    return {
      newSection: "",
    };
  },
  methods: {
    update(currentItem, newSection) {
      if (!newSection || newSection == " ") {
        return;
      }
      const itemInfo = [currentItem, newSection];
      this.$emit("update", itemInfo);
      this.newSection = "";
    },
    cancel() {
      this.newSection = "";
      this.$emit("cancel");
    },
    filteredSections(sections, currentItem) {
      return sections.filter((s) => s !== currentItem.section);
    },
  },
};
</script>

<style scoped>
.specification-list__item {
  min-height: 10px;
}
</style>
